var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"ds-spinner",class:[
    ("ds-size-" + (this.size)),
    _vm.inverse && 'ds-spinner-inverse',
    _vm.primary && !_vm.inverse && "ds-spinner-primary",
    _vm.secondary && !_vm.inverse && "ds-spinner-secondary",
    _vm.danger && !_vm.inverse && "ds-spinner-danger"
  ],attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"ds-spinner-circle",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }